import { LitElement, html, css } from "lit";
import "@matter/matter-icon/dist/matter-icon.js";

class MatterCardBackground extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main: #087021;
        --main-hover: #0b4c1a;
        --grey-main: #333333;
        --icon-color: #c4ddca;
        --white: #ffffff;

        --width: 100%;
        --height: 280px;
        --padding: 15px;
        --gray: #7c7c7c;
      }

      .slot {
        line-height: 1.5;
      }

      .card {
        border: 1px solid #d8d8d8;
        width: var(--width);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        transition: all 0.5s ease-in;
        background-color: var(--main-hover);
      }
      
      @media (min-width: 991px) {
        .card{
          min-height: 337px;
        }
      }

      .card:hover {
        transition: all 0.5s ease-out;
        box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
        top: -4px;
        border: 1px solid #cccccc;
      }

      .container {
        padding: 36px 20px;
      }

      .container .text,
      .container .link {
        color: var(--white);
      }
      .container a {
        text-decoration: none;
      }

      :host([size="topic"]) {
        --width: 242px;
        --height: 280px;
      }

      :host([size="s"]) {
        --width: 250px;
        --height: 480px;
      }

      :host([size="m"]) {
        --width: 270px;
        --height: 480px;
      }

      :host([size="l"]) {
        --width: 290px;
        --height: 480px;
      }
    `;
  }

  static get properties() {
    return {
      card_size: { type: String },
      icon: { type: String, reflect: true },
      icon_size: { type: String },
      icon_color: { type: String },
      icon_theme: { type: String },
      text: { type: String },
      href: { type: String },
      target: { type: String },
      anchor_text: { type: String },
    };
  }

  constructor() {
    super();
    this.card_size = "";
    this.icon = "";
    this.icon_size = "";
    this.icon_color = "";
    this.icon_theme = "secondary";
    this.text = "";
    this.href = "#";
    this.target = "_self";
    this.anchor_text = "";
  }

  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  firstUpdated() {
    this.addFont();
  }

  render() {
    return html`
      <div
        class="card"
        style=${this.card_size === "topic" ? `width:242px; height:280px` : ""}
      >
        <div class="container">
          ${this.icon !== ""
            ? html`
                <i
                  ><matter-icon
                    .icon="${this.icon}"
                    .theme="${this.icon_theme}"
                    .size="${this.icon_size}"
                    .color="${this.icon_color}"
                  ></matter-icon
                ></i>
              `
            : " "}
          ${this.text !== "" ? html` <p class="text">${this.text}</p> ` : ""}
          ${this.anchor_text !== ""
            ? html` <a href="${this.href}" class="link" target="${this.target}">
                ${this.anchor_text} &#10141;
              </a>`
            : ""}
        </div>
      </div>
    `;
  }
}

if (!window.customElements.get("matter-card-background")) {
  window.customElements.define("matter-card-background", MatterCardBackground);
}
